import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/map";

import { Aeroporto } from "../../model/";

import { TURISMO, TURISMO_AEREO, TURISMO_HOTEL, ITENSPORPAGINA } from "../../app.config";

@Injectable()
export class AeroportoService {
    constructor(private http: HttpClient) {}

    buscarPorParametro(param: string, pagina: Number): Observable<any> {
        const headers = new HttpHeaders().set("noloader", "t");

        if (param.length > 0) {
            return this.http.get<any>(
                `${TURISMO}/api/Aeroporto/list/${param.trim()}?Pagina=${pagina}&ItensPorPagina=${ITENSPORPAGINA}`,
                { headers: headers }
            );
        } else {
            return this.http.get<any>(`${TURISMO}/api/Aeroporto?Pagina=${pagina}&ItensPorPagina=${ITENSPORPAGINA}`, {
                headers: headers,
            });
        }
    }

    buscarPorId(id: number): Observable<any> {
        return this.http.get<any>(`${TURISMO}/api/Aeroporto/${id}?Pagina=1&ItensPorPagina=${ITENSPORPAGINA}`);
    }

    remover(id: Number): Observable<any> {
        return this.http.delete<any>(`${TURISMO}/api/Aeroporto/${id}`);
    }

    salvar(aeroporto: Aeroporto): Observable<any> {
        if (aeroporto.Id > 0) {
            return this.http.put<any>(`${TURISMO}/api/Aeroporto/${aeroporto.Id}`, aeroporto);
        } else {
            return this.http.post<any>(`${TURISMO}/api/Aeroporto/`, aeroporto);
        }
    }
}
